import { IServicePeriods } from '../../../../../redux/reducers';
import { IServicePeriodSchema } from '../../../../../repositories/billing-tariffs/v1/publish-terms';
import { mapPeriod } from '../mapPeriod';

export function mapPeriods(periods: IServicePeriodSchema[]): IServicePeriods {
  return periods.reduce((acc, rawPeriod) => {
    const period = mapPeriod(rawPeriod);

    acc[period.id] = period;

    return acc;
  }, {} as IServicePeriods);
}
